export default __webpack_public_path__ + "static/media/t40.e7d7ce79.jpg";